export default __webpack_public_path__ + "static/font-b2cd9bf47d8ad4e3f5475c93d50f8504.woff";